<template>
    <!-- <AppLayout :title="title"> -->
        <div class="d-flex justify-center">
            <div class="w-50rem max-w-100">
                <form @submit.prevent="store">
                    <v-card>
                        <v-card-text>
                            <div class="d-flex flex-column ga-5">
                                <div v-if="form.errors.custom_error" class="fs-1 pb-2 text-error">
                                    {{ form.errors.custom_error }}
                                </div>
                                <div>
                                    <v-text-field-v1
                                        label="Signwell Token"
                                        v-model="form.SIGNWELL_TOKEN"
                                        placeholder=""
                                        :error-messages="form.errors.SIGNWELL_TOKEN"
                                    ></v-text-field-v1>
                                </div>
                                <div>
                                    <v-text-field-v1
                                        label="Meow API Key"
                                        v-model="form.MEOW_TOKEN"
                                        placeholder=""
                                        :error-messages="form.errors.MEOW_TOKEN"
                                    ></v-text-field-v1>
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-actions-form>
                            <div class="d-flex flex-grow-1 justify-space-between">
                                <v-btn-input-compact color="btn-secondary"  @click="helpers.goBack">
                                    <template #prepend>
                                        <mdi-icon>chevron_left</mdi-icon>
                                    </template>
                                    Back
                                </v-btn-input-compact>
                                <v-btn-input-compact type="submit" :disabled="form.processing" :loading="form.processing">
                                    <template #prepend>
                                        <mdi-icon>check</mdi-icon>
                                    </template>
                                    <span>Update</span>
                                </v-btn-input-compact>
                            </div>
                            
                        </v-card-actions-form>
                    </v-card>
            
                </form>
            </div>
        </div>
    <!-- </AppLayout> -->
</template>
<script setup lang="ts">
    import { computed, ref } from "vue";
    import { useForm, usePage } from '@inertiajs/vue3';
    import { toast } from 'vue3-toastify';
    import { SharedPage, SharedPageProps } from '@/Types/inertia';
    import { SettingType, SettingTypes } from '@/Types/Models/setting';
    import helpers from '@/Plugins/helpers';
    import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';

    containerGapForForm();
    interface PageData extends SharedPageProps{
        data?:{
            settings?: SettingTypes,
        }
    }

    interface Form extends SettingTypes{
        custom_error: string,
    }

    pageTitle.value = `Settings`;
    const page = usePage<PageData>();
    const settings = computed(() => page.props.data?.settings ?? {});
    const formData: SettingTypes = {};
    for(let [key, value] of Object.entries(settings.value)){
        formData[key as SettingType] = value;
    }
    const form = useForm<Form>({
        custom_error: '',
        ...formData
    });
    
    const store = () => {
        form.post(route('settings.store'), {
            onSuccess: (page2: SharedPage) => {
                // console.log('page onSuccess', page);
                form.clearErrors();
                console.log(page.props?.data)
                toast.success(page2.props?.jetstream?.flash?.msg?.text ?? 'Settings updated successfully');
            },
            onFinish: (visit) => {
                // console.log('visit onFinish', visit);
            },
            onError: (errors) => {
                console.log('onError', errors);
            }
        });
    };
</script>